// extracted by mini-css-extract-plugin
module.exports = {"pcTitle":"PageHeader_pcTitle__1GW-W","wrapper":"PageHeader_wrapper__2XV2M","title":"PageHeader_title__11eoz","iconLeft":"PageHeader_iconLeft__2LVU0"};